import {Component, Input, OnInit} from '@angular/core';
import {DateTimeRangeDTO} from 'src/app/services/api/api';
import {ModalNavigationComponent} from 'src/app/services/gui/modal/modal-navigation-component';
import {ModalNavigationService} from 'src/app/services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-date-time-range-viewer',
  templateUrl: './sb-date-time-range-viewer.component.html',
  styleUrls: ['./sb-date-time-range-viewer.component.scss'],
  standalone: false,
})
export class SbDateTimeRangeViewerComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  @Input()
  dateTimeRanges: DateTimeRangeDTO[];

  constructor(private modalNavigation: ModalNavigationService) {}

  ngOnInit() {
    if (this.isInModalContext) {
      if (this.modalNavigation.getCurrentNavigation().data && this.modalNavigation.getCurrentNavigation().data.dateTimeRanges) {
        this.dateTimeRanges = this.modalNavigation.getCurrentNavigation().data.dateTimeRanges;
      }
    }
  }

  chosenMonthChanged($event) {}
}
